import scores from "@/assets/eco-repair-scores.json";

function fromRecord(record) {
  if (!record || !record.score) return null;
  return {
    score: String(record.score),
    secondHandCO2: Number(record.secondHandCO2),
    newCO2: Number(record.newCO2),
  };
}

export function ecoScoreFor(part) {
  if (!part) return null;
  const onPart = fromRecord(part.ecoScore);
  if (onPart) return onPart;
  const keys = [part._id, part.old_id].filter(Boolean).map(String);
  for (let i = 0; i < keys.length; i += 1) {
    const found = fromRecord(scores[keys[i]]);
    if (found) return found;
  }
  return null;
}
